import { api } from '../../lib/apiClient';

export type WebhookDTO = {
  id: string;
  kind: string;
  url: string;
  created_at: string;
  updated_at: string;
};

export type UpsertWebhookResponse = WebhookDTO & {
  secret: string;
};

export async function getRecoveryWebhook(orgId: string): Promise<WebhookDTO | null> {
  try {
    const res = await api.get<{ data: WebhookDTO }>(`/v1/orgs/${orgId}/webhooks/recovery`);
    return res.data.data;
  } catch (e: unknown) {
    if (typeof e === 'object' && e && 'response' in e) {
      const status = (e as { response?: { status?: number } }).response?.status;
      if (status === 404) return null;
    }
    throw e;
  }
}

export async function upsertRecoveryWebhook(orgId: string, url: string): Promise<UpsertWebhookResponse> {
  const res = await api.put<{ data: UpsertWebhookResponse }>(
    `/v1/orgs/${orgId}/webhooks/recovery`,
    { url },
  );
  return res.data.data;
}

export async function deleteRecoveryWebhook(orgId: string): Promise<void> {
  await api.delete(`/v1/orgs/${orgId}/webhooks/recovery`);
}
